import React from "react";
import { Image, Text, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { AppScreens } from "../../screens/Utility/AppScreens";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../Separator";
import { CommonButton } from "../../common/CommonButton";
import MyBeltsSkeleton from "../skeleton-components/MyBeltsSkeleton";
import BuyBeltWalkthrough from "../walk-through-common-components/profileTooltips/BuyBeltWalkthrough";
import BeltsWalkthrough from "../walk-through-common-components/profileTooltips/BeltsWalkthrough";
import SvgImage from "../choose-avatar-components/SvgImage";

const MyBelts = ({
  setCornfirmPurchaseBeltModal,
  setSaleBeltModal,
  arrBeltMedalType,
  setArrBeltMedalType,
  isEditable = true,
  isLoading = false,
  setActiveTab,
  scrollViewRef = null,
}) => {
  const navigation = useNavigation();
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  // Format large numbers to max 5 digits with K/M/B suffix
  const formatCredit = (value) => {
    if (!value || value === 0) return "0";
    if (value >= 1000000000) {
      return (value / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
    }
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (value >= 10000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return value.toString();
  };

  return isLoading ? (
    <MyBeltsSkeleton />
  ) : (
    <View style={{ flex: 1 }}>
      <LinearGradient
        colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={{
          flex: 1,
          margin:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 1
              : 0,
          padding:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 12
              : 24,
          borderColor: "#374151",
          borderWidth: 0.8,
          borderRadius: 8,
        }}
      >
        {/* Parent View with Two Columns */}
        <View
          style={{
            flexDirection:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "column"
                : "row",
            gap: 24,
            alignItems: "stretch",
          }}
        >
          {/* Column 1: Belts Section */}
          <View style={{ flex: 1, flexDirection: "column" }}>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "column"
                    : "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
              }}
            >
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "100%"
                      : "auto",
                }}
              >
                <BeltsWalkthrough
                  scrollViewRef={scrollViewRef}
                  setActiveTab={setActiveTab}
                />
              </View>
              {isEditable && (
                <View
                  style={{
                    flexDirection: "row",
                    ...(deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? { width: "100%", justifyContent: "space-between" }
                      : { gap: 16 }),
                  }}
                >
                  <CommonButton
                    buttonStyle={styles.ViewTransactionHistoryButtonStyle}
                    textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                    title="View transaction history"
                    onTap={() => {
                      navigateToScreen(
                        navigation,
                        AppScreens.ViewTrasactionHistory
                      );
                    }}
                  />
                  <BuyBeltWalkthrough
                    setActiveTab={setActiveTab}
                    scrollViewRef={scrollViewRef}
                    content={
                      <LinearGradient
                        colors={["#DC2626", "#991B1B"]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        style={{ borderRadius: 6 }}
                      >
                        <CommonButton
                          buttonStyle={[
                            styles.buyBeltButtonStyle,
                            { minWidth: 80 },
                          ]}
                          textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                          title="Buy Belt"
                          onTap={() => {
                            setCornfirmPurchaseBeltModal(true);
                          }}
                        />
                      </LinearGradient>
                    }
                  />
                </View>
              )}
            </View>
            <Separator
              color="#374151"
              height={1}
              marginTop={12}
              marginBottom={12}
              marginHorizontal={0}
            />
            <View
              style={{
                flexDirection: "row",
                flexWrap:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "wrap"
                    : "nowrap",
                gap: 12,
                flex: 1,
              }}
            >
              {arrBeltMedalType.map((item, index) => {
                if (index === 0) return null;
                return (
                  <View
                    key={index}
                    style={{
                      alignItems: "center",
                      ...(deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? {
                            width: "48%",
                            minWidth: 140,
                          }
                        : { flex: 1 }),
                    }}
                  >
                    <View style={{ flex: 1, width: "100%", minHeight: 200 }}>
                      <LinearGradient
                        colors={["#1F2937", "#111827"]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 0, y: 1 }}
                        style={{
                          flex: 1,
                          borderRadius: 8,
                          borderWidth: 0.8,
                          borderColor: "#374151",
                          marginBottom: 12,
                          alignItems: "center",
                          justifyContent: "center",
                          paddingVertical: 20,
                          paddingHorizontal: 8,
                          paddingBottom: 56,
                          gap: 12,
                        }}
                      >
                        <Text
                          style={
                            deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                              ? AppFontStyle.BOLD_ANYBODY_18
                              : AppFontStyle.BOLD_ANYBODY_14
                          }
                        >
                          {item.title}
                        </Text>

                        <SvgImage src={item.image} variant="profileMedal" />
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 6,
                            alignItems: "center",
                            flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={
                              deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                                ? AppFontStyle.MEDIUM_ANYBODY_14
                                : AppFontStyle.MEDIUM_ANYBODY_12
                            }
                          >
                            Credit
                          </Text>
                          <Text
                            style={
                              deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                                ? AppFontStyle.BOLD_ANYBODY_20
                                : AppFontStyle.BOLD_ANYBODY_16
                            }
                            numberOfLines={1}
                          >
                            {formatCredit(item.value * item.currentPrize)}
                          </Text>
                        </View>
                      </LinearGradient>
                      <View
                        style={{
                          backgroundColor: AppColors.black,
                          borderRadius: 5,
                          padding: 6,
                          position: "absolute",
                          left: 0,
                          right: 0,
                          bottom: 12,
                          marginHorizontal: 4,
                        }}
                      >
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_18,
                            { textAlign: "center" },
                          ]}
                          numberOfLines={1}
                        >
                          {item.value}
                        </Text>
                      </View>
                    </View>
                    {isEditable && (
                      <CommonButton
                        buttonStyle={styles.ConvertButtonStyle}
                        textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                        title="Convert"
                        onTap={() => {
                          {
                            const tempArr = [...arrBeltMedalType];
                            tempArr.map((item) => {
                              item.isSelected = false;
                            });
                            tempArr[index].isSelected =
                              !tempArr[index].isSelected;
                            setArrBeltMedalType(tempArr);
                            setSaleBeltModal(true);
                          }
                        }}
                      />
                    )}
                  </View>
                );
              })}
            </View>
          </View>

          {/* TODO: Implement Diamond Achievement Section - Hidden until feature is complete */}
          {/* Column 2: Diamond Achievement Section */}
          {/* {deviceSize !== DEVICE_SIZES.MD && (
            <View
              style={{
                ...(deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM
                  ? { width: "100%", marginTop: 12 }
                  : { minWidth: 200, maxWidth: 220 }),
              }}
            >
              <LinearGradient
                colors={["#1F2937", "#111827"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  padding: 16,
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 12,
                  flex: 1,
                  borderRadius: 6,
                  borderWidth: 0.8,
                  borderColor: "#374151",
                }}
              >
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_12,
                    { textAlign: "center", maxWidth: 180, lineHeight: 16 },
                  ]}
                >
                  Unlock all belts up to Platinum and earn the ultimate
                  achievement!
                </Text>

                <Image
                  source={AppImages.ko_diamond}
                  style={{
                    width: 90,
                    height: 90,
                    resizeMode: "contain",
                  }}
                />

                <Text style={AppFontStyle.BOLD_ANYBODY_20}>Diamond</Text>

                <View style={{ gap: 6, alignItems: "center" }}>
                  <Text style={AppFontStyle.MEDIUM_ANYBODY_12}>
                    Unlock Reward
                  </Text>

                  <View
                    style={{
                      flexDirection: "row",
                      gap: 6,
                      alignItems: "center",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    <Text style={AppFontStyle.BOLD_ANYBODY_14}>4500 KO</Text>
                    <Text style={AppFontStyle.MEDIUM_ANYBODY_12}>Worth</Text>
                    <Text style={AppFontStyle.BOLD_ANYBODY_20}>50$</Text>
                  </View>

                  <Text
                    style={[
                      AppFontStyle.MEDIUM_ANYBODY_10,
                      { textAlign: "center", maxWidth: 160, lineHeight: 14 },
                    ]}
                  >
                    Diamond Badge Assigned to Profile
                  </Text>
                </View>
              </LinearGradient>
            </View>
          )} */}
        </View>
      </LinearGradient>
    </View>
  );
};

export default MyBelts;

const useStyles = CreateResponsiveStyle(
  {
    ViewTransactionHistoryButtonStyle: {
      height: 34,
      paddingVertical: 12,
      paddingHorizontal: 12,
      backgroundColor: "transparent",
      shadowColor: "rgba(0, 0, 0, 0.25)",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 4,
      borderRadius: 6,
      borderWidth: 1,
      borderColor: AppColors.white,
    },
    buyBeltButtonStyle: {
      width: 105,
      height: 32,
      paddingVertical: 10,
      paddingHorizontal: 24,
      shadowOpacity: 0,
      borderRadius: 6,
      borderWidth: 0,
      backgroundColor: "transparent",
    },
    ConvertButtonStyle: {
      width: "100%",
      maxWidth: 134,
      height: 34,
      paddingVertical: 12,
      paddingHorizontal: 12,
      backgroundColor: "transparent",
      shadowColor: "rgba(0, 0, 0, 0.25)",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 4,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: AppColors.white,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      ConvertButtonStyle: {
        width: "100%",
        maxWidth: 110,
        paddingHorizontal: 8,
      },
    },
    [DEVICE_SIZES.LG]: {
      ConvertButtonStyle: {
        width: "100%",
        maxWidth: 120,
        paddingHorizontal: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      ConvertButtonStyle: {
        width: "100%",
        maxWidth: 100,
        paddingHorizontal: 6,
      },
    },
    [DEVICE_SIZES.XS]: {
      ConvertButtonStyle: {
        width: "100%",
        maxWidth: 90,
        paddingHorizontal: 4,
      },
    },
  }
);
